import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GuestWallDialog from './GuestWallDialog';
import { GUEST_WALL_EVENT } from './guest';

/**
 * The guest signup wall — one dialog for every gated action on the guest
 * surfaces (anonymous access v1 §8). Opened from anywhere via
 * `openGuestWall(message?)` (features/auth/guest.ts); confirming goes to
 * signup with `?next=` back to the page the guest was on, so the claimed
 * trip greets them right after signing up.
 */
const DEFAULT_MESSAGE =
  'This needs a free Jody account. Your trip comes with you when you sign up.';

const GuestWallHost: React.FC = () => {
  const [message, setMessage] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onWall = (e: Event) => {
      const detail = (e as CustomEvent).detail as { message?: string } | undefined;
      setMessage(detail?.message || DEFAULT_MESSAGE);
    };
    window.addEventListener(GUEST_WALL_EVENT, onWall);
    return () => window.removeEventListener(GUEST_WALL_EVENT, onWall);
  }, []);

  const goTo = useCallback((base: '/signup' | '/login') => {
    setMessage(null);
    const next = encodeURIComponent(location.pathname + location.search);
    navigate(`${base}?next=${next}`);
  }, [location.pathname, location.search, navigate]);

  if (!message) return null;
  return (
    <GuestWallDialog
      message={message}
      onSignup={() => goTo('/signup')}
      onLogin={() => goTo('/login')}
      onDismiss={() => setMessage(null)}
    />
  );
};

export default GuestWallHost;
